import { render, staticRenderFns } from "./listProductRedemptions.vue?vue&type=template&id=6ffdfdd0&scoped=true&"
import script from "./listProductRedemptions.vue?vue&type=script&lang=js&"
export * from "./listProductRedemptions.vue?vue&type=script&lang=js&"
import style0 from "./listProductRedemptions.vue?vue&type=style&index=0&id=6ffdfdd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffdfdd0",
  null
  
)

export default component.exports